import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { HelpLink } from '../HelpLink';
import { StateEditDialog } from './StateEditDialog';

const STATUS = {
  collecting: ['Collecting', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
  not_collecting: ['Not collecting', 'bg-neutral-100 text-neutral-600 border-neutral-200'],
  review: ['Review needed', 'bg-red-50 text-red-700 border-red-200'],
};
const REG = { yes: 'Yes', no: 'No', review: 'Review needed' };
const day = (v) => (v ? new Date(v).toLocaleDateString() : '—');

export const TaxStatesPanel = ({ states, canEdit, token, onSaved }) => {
  const [q, setQ] = useState('');
  const [onlyFlagged, setOnlyFlagged] = useState(false);
  const [editing, setEditing] = useState(null);
  const rows = states.filter((s) => `${s.name} ${s.code}`.toLowerCase().includes(q.toLowerCase()) && (!onlyFlagged || s.status !== 'not_collecting' || s.last_reviewed_at));
  return (
    <div className="bg-white border rounded-lg p-4" data-testid="tax-states-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <p className="text-sm font-medium flex items-center gap-2">States — nexus & collection <HelpLink topic="tax-out-of-state" testId="help-link-state-settings" /></p>
        <div className="flex items-center gap-3">
          <label className="text-xs flex items-center gap-1"><input type="checkbox" checked={onlyFlagged} onChange={(e) => setOnlyFlagged(e.target.checked)} data-testid="tax-states-only-configured" /> Configured / flagged only</label>
          <Input placeholder="Search state" value={q} onChange={(e) => setQ(e.target.value)} className="w-44 h-8" data-testid="tax-states-search" />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead><tr className="text-left text-neutral-500 border-b">
            {['State', 'Status', 'Registered / nexus', 'Collection', 'Effective', 'Physical activity', 'Threshold / reference', 'Rate source / method', 'Last reviewed', 'Admin notes', ''].map((h) => <th key={h} className="py-2 pr-3 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>{rows.map((s) => {
            const [label, cls] = STATUS[s.status];
            return (
              <tr key={s.code} className="border-b align-top" data-testid={`tax-state-row-${s.code}`}>
                <td className="py-2 pr-3 font-medium text-sm">{s.name}</td>
                <td className="py-2 pr-3"><span className={`px-2 py-0.5 rounded-full border ${cls}`} data-testid={`tax-state-status-${s.code}`}>{s.nexus_review ? 'Nexus review needed' : label}</span></td>
                <td className="py-2 pr-3">{REG[s.registered]}</td>
                <td className="py-2 pr-3">{s.collect ? 'On' : 'Off'}</td>
                <td className="py-2 pr-3">{s.effective_date || '—'}</td>
                <td className="py-2 pr-3">{s.physical_activity ? <span className="text-red-700" title={s.activity_notes}>Yes</span> : 'No'}</td>
                <td className="py-2 pr-3 max-w-[10rem]">{s.threshold_note || '—'}</td>
                <td className="py-2 pr-3 max-w-[10rem]">{s.rate_source || (s.collect ? 'None connected' : '—')}</td>
                <td className="py-2 pr-3">{s.last_reviewed_at ? `${day(s.last_reviewed_at)} · ${s.last_reviewed_by}` : '—'}</td>
                <td className="py-2 pr-3 max-w-[10rem]">{s.admin_notes || '—'}</td>
                <td className="py-2">{canEdit && s.code !== 'NY' && <Button size="sm" variant="outline" className="h-7" onClick={() => setEditing(s)} data-testid={`tax-state-edit-${s.code}`}>Edit</Button>}</td>
              </tr>
            );
          })}</tbody>
        </table>
      </div>
      {editing && <StateEditDialog state={editing} token={token} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); onSaved(); }} />}
    </div>
  );
};
